import { useState, useCallback, useEffect } from "react";
import { globalConstants } from "../../constants";

const useCompanyStoreFilter = (
  currentStoreCompany,
  currentStore,
  stores,
  defaultToCurrentStore = false
) => {
  const [selectedStore, setSelectedStore] = useState({
    label: globalConstants.ALL_STORES,
    value: globalConstants.ALL_STORES,
  });

  const companyStores =
    stores?.filter((store) => store.companyId === currentStoreCompany?.id) ||
    [];

  const getCompanyId = useCallback(() => {
    return currentStoreCompany &&
      selectedStore?.label === globalConstants.ALL_STORES
      ? currentStoreCompany.id
      : undefined;
  }, [currentStoreCompany, selectedStore?.label]);

  const targetStoreId = currentStoreCompany?.isDummyCompany
    ? currentStore?.id
    : selectedStore?.value;

  useEffect(() => {
    if (defaultToCurrentStore && currentStore?.id) {
      setSelectedStore({
        label: currentStore.storeName,
        value: currentStore.id,
      });
    }
  }, [currentStore?.id, defaultToCurrentStore]);

  return {
    selectedStore,
    setSelectedStore,
    companyStores,
    getCompanyId,
    targetStoreId,
  };
};
export default useCompanyStoreFilter;
export { useCompanyStoreFilter };
